module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_MasjidBaitusSalam_14.dcf3332b.jpeg";